module.exports = __webpack_public_path__ + "img/service-2.png";